import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "input-error" }
const _hoisted_7 = { class: "col-lg-4 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { class: "input-error" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-8 col-sm-6" }
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = {
  key: 0,
  class: "input-error"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "form-group mb-4" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "input-error" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_26 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilePond = _resolveComponent("FilePond")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label text-secondary" }, "Código", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el código del trofeo",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prize.code) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('code')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.prize.code,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.errors.code), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre del trofeo",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prize.name) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('name')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.prize.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errors.name), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                style: {"resize":"none"},
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar la descripción del trofeo",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prize.description) = $event)),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('description')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.prize.description,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.errors.description), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label text-secondary" }, "Foto del Trofeo", -1 /* HOISTED */)),
              (_ctx.prize.urlPhoto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: _ctx.prize.urlPhoto,
                      alt: "Foto del Trofeo",
                      class: "img-fluid mb-2 d-block"
                    }, null, 8 /* PROPS */, _hoisted_18),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removePhoto && _ctx.removePhoto(...args)), ["prevent"])),
                      class: "btn btn-danger btn-sm"
                    }, " Eliminar foto ")
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.prize.urlPhoto)
                ? (_openBlock(), _createBlock(_component_FilePond, {
                    key: 1,
                    name: "FilePhoto",
                    maxFileSize: '2MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(', ')}`,
                    credits: "",
                    "allow-image-preview": true,
                    "image-preview-height": 200,
                    onUpdatefiles: _ctx.handleUpdateFiles,
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('filePhoto')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.errors.filePhoto), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_RouterLink, { to: "/prizes" }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.prize.id == 0 ? "Crear" : "Actualizar"), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_23)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}